import { useInject } from 'dependable-react';
import { css } from 'emotion';
import React, { useEffect, useState } from 'react';
import { APP_DATA_TOKEN } from '../../services/InjectTokens';
import { pushGtmData } from '../../utils/gtm';
import { PageLoader } from '../PageContent/components/PageLoader';

const pageStyles = css`
  width: 50%;
  height: 100%;
  position: absolute;
  transition: transform 0.8s ease, opacity 0.2s ease;
  cursor: pointer;
  backface-visibility: hidden;
  will-change: transform, opacity;
  overflow: hidden;
  opacity: 0;

  &.is-visible {
    opacity: 1;
  }

  &.is-active:nth-child(odd) ~ .page:nth-child(odd) {
    transform: rotateY(0);
  }

  &.is-active:nth-child(odd) ~ .page:nth-child(2n) {
    transform: rotateY(180deg);
  }

  &.is-active {
    z-index: 2;
  }
  &.is-animating {
    z-index: 4;
    &:nth-child(odd) {
      z-index: 4;
    }
  }
  &.was-active {
    z-index: 1;
  }

  &:nth-child(odd) {
    transform-origin: 0;
    right: 0;
    transform: rotateY(-180deg);
    &.is-active {
      transform: rotateY(-2deg);

      &:hover {
        transform: rotateY(-12deg);
      }
    }
  }
  &:nth-child(even) {
    transform-origin: 100%;
    left: 0;
    &.is-active {
      transform: rotateY(2deg);
      &:hover {
        transform: rotateY(12deg);
      }
    }
  }
`;

const coverInnerStyle = (coverDimensions: any, isCoverFront: boolean, isWideFormat: boolean) => css`
  width: ${coverDimensions.width}mm;
  height: ${coverDimensions.height}mm;

  // Who ever sees this before refactor,
  // I AM SORRY!, there was no other way for the current implementation
  // Sincerely,
  // fly
  transform: scaleX(0.895) scaleY(${isWideFormat ? '0.855' : '0.903'}) translateY(${isWideFormat ? '-82px' : '-70px'})
    translateX(
      ${isCoverFront && !isWideFormat
        ? '-56%'
        : isCoverFront && !isWideFormat
        ? '-6%'
        : isCoverFront && isWideFormat
        ? '-53.5%'
        : '-6%'}
    );
`;

export const Page = ({ page, className, isCoverFront, isCoverBack, coverDimensions, children, ...rest }: any) => {
  const appState = useInject(APP_DATA_TOKEN);
  const [totalImages, setTotalImages] = useState(0);
  const [loadedImages, setLoadedImages] = useState(0);
  const [initialLoaded, setInitialLoaded] = useState(false);
  useEffect(() => {
    setLoadedImages(0);
    const pageContent = document.getElementById(`page-${page}-content`);

    if (isCoverFront) {
      pushGtmData({ event: 'personalizacija', korak: { items: [{ step: `step_book_title` }] } });
    }

    let images: Array<HTMLImageElement>;
    if (pageContent) {
      images = [...Array.from(pageContent.getElementsByTagName('img'))];
      setTotalImages(images.length);
      images.forEach((image) => {
        image.addEventListener('load', () => {
          setLoadedImages((prevState) => prevState + 1);
        });
      });
    }
  }, [appState.avatars, appState.currentLanguage]);

  useEffect(() => {
    if (loadedImages === totalImages && loadedImages !== 0 && totalImages !== 0) {
      setInitialLoaded(true);
    }
  }, [loadedImages, totalImages]);

  if (isCoverFront || isCoverBack) {
    return (
      <div className={`${pageStyles} ${className}`}>
        {!initialLoaded && <PageLoader />}
        <div className={coverInnerStyle(coverDimensions, isCoverFront, appState.isWideFormat)} {...rest}>
          {children}
        </div>
      </div>
    );
  }

  return (
    <div className={`${pageStyles} ${className}`} {...rest}>
      {!initialLoaded && <PageLoader />}
      {children}
    </div>
  );
};
